import './EmailVerification.scss'

import { useState, useEffect, useRef } from 'react';
import { api } from '../../../utils/api';
import { useCurrentUser } from '../../../UserProvider';

export default function EmailVerification({setCanProceed}) {
  const { currentUser, setCurrentUser } = useCurrentUser();
  const [verificationCode, setVerificationCode] = useState('');
  const [checkingCode, setCheckingCode] = useState(false);
  const [invalidCode, setInvalidCode] = useState(false);
  const hasRequestedCode = useRef(false);

  useEffect(() => {
    if (!hasRequestedCode.current && currentUser && currentUser.email_verified === false) {
      api.post('/email_verifications');
      hasRequestedCode.current = true;
    }
  }, [currentUser]);

  useEffect(() => {
    if (!checkingCode && verificationCode.length === 6) {
      const submitCode = async () => {
        try {
          setCheckingCode(true);
          setInvalidCode(false);
          await api.put('/email_verifications', { code: verificationCode });
          setCheckingCode(false);
          setCanProceed(true);
          setCurrentUser(prev => ({ ...prev, email_verified: true }));
        } catch (err) {
          setCheckingCode(false);
          setInvalidCode(true);
        }
      };

      submitCode();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verificationCode]);

  const handleResendCode = () => {
    setVerificationCode('');
    setInvalidCode(false);
    api.post('/email_verifications');
  };

  // If already verified, show success and skip the rest of the UI
  if (currentUser?.email_verified) {
    setCanProceed(true);
    return (
      <div className="__email_verification success">
        <div className="title">Email verified</div>
        <div className="sub-title">Your email address has been successfully verified.</div>
      </div>
    );
  }

  return (
    <div className='__email_verification'>
      <div className='title'>Verify your email address</div>
      <div className='sub-title'>Enter the 6-digit verification code</div>
      { checkingCode && <div className='code-status'>Checking Code...</div> }
      { invalidCode && <div className='code-status invalid'>Invalid Code</div> }
      <input
        type="text"
        placeholder="• • • • • •"
        value={verificationCode}
        maxLength={6}
        onChange={(e) => setVerificationCode(e.target.value)}
      />
      <div>Click <span onClick={handleResendCode}>here</span> to receive a new code</div>
    </div>
  );
}